export enum ReportTitleBlock {
  Root = 'ReportTitle',
}
